
import XLSX from 'xlsx';
import firebase from 'firebase'
import { db } from '@/firebase'
import { key } from 'firebase-key';


export default {
    importarExcelClicktom({ rootState }, fichero) {
        var reader = new FileReader();
        var name = fichero.name;
        const negocio = rootState.app.negocioGest;

        reader.onload = function (e) {
            var data = e.target.result;

            var workbook = XLSX.read(data, { type: 'binary' });
            console.log(Object.values(workbook.Sheets))

            let array = (Object.values(workbook.Sheets).map(hoja => {
                return XLSX.utils.sheet_to_json(hoja)
            })).flat()

            console.log(array);
            var noImportados
            var actualesImportados
            return db.collection('negocios').doc(negocio)
                .collection('clientes')
                .where('importado', '==', 'clicktom').get()
                .then(r => {
                    actualesImportados = r.docs.map(c => {
                        return {
                            ...c.data(),
                            id: c.id
                        }
                    })
                })

                .then(() => {
                    noImportados = array.filter(c => actualesImportados.findIndex(act => c['Teléfono'] && act.localTelefono == c['Teléfono'].toString()) < 0)
                    console.log("noImportados")
                    console.log(noImportados)
                    console.log("actualesImportados")
                    console.log(actualesImportados)
                    return Promise.all(noImportados.map(c => {
                        let insert =
                        {
                            canalRegistro: 'tpv',
                            direccionesLocal: c['Dirección'] && c['Dirección'].length ? [
                                {
                                    direccionLocal: true,
                                    id: key(),
                                    calle: c['Dirección'],
                                    numero: "",
                                    adicional: "",
                                    municipio: "",
                                    cp: c['Código Postal'] ? c['Código Postal'] : '',
                                    provincia: "",
                                    coordenadas: [],
                                    pais: "",
                                }
                            ] : [],
                            displayName: c['Nombre Fiscal'] ? c['Nombre Fiscal'] : '',
                            email: c.Email ? c.Email : '',
                            phoneNumber: '',
                            fecha: firebase.firestore.Timestamp.now(),
                            importado: 'clicktom',
                            importadoFecha: firebase.firestore.Timestamp.now(),
                            localNombre: c['Nombre Fiscal'] ? c['Nombre Fiscal'] : '',
                            localApellido1: '',
                            localApellido2: '',
                            localTelefono: c['Teléfono'] ? c['Teléfono'].toString() : '',
                            role: 'cliente',
                            restaurantes: rootState.restaurantes.restaurantesArray.map(r => r.id),
                            //facturarción
                            facturacionRazonSocial: c['Nombre Fiscal'] ? c['Nombre Fiscal'] : '',
                            facturacionNifCif: "",
                            facturacionCp: c['Código Postal'] ? c['Código Postal'] : '',
                            facturacionDireccion: c['Dirección'] ? c['Dirección'] : '',
                            facturacionProvincia: "",
                            facturacionMunicipio: "",
                        }
                        return db.collection('negocios').doc(negocio).collection('clientes').add(insert)
                    }))
                })


            /* DO SOMETHING WITH workbook HERE */
        };
        reader.readAsBinaryString(fichero);
    }
}